'use client';

import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { DeliveryType } from '@/features/enums/DeliveryType';
import { SelectVenueModalContext } from './SelectVenueModalProvider';
import './styles.scss';

export const SelectVenueModalTitle = () => {
    const t = useTranslations();
    const { formMethods, areSearchFieldsVisible } = useContext(SelectVenueModalContext);

    const deliveryType = useWatch({ control: formMethods.control, name: 'deliveryType' });

    return (
        <>
            {!areSearchFieldsVisible
                ? t('SELECT_VENUE_MODAL.TITLE')
                : deliveryType === DeliveryType.DELIVERY
                  ? t(`SELECT_VENUE_MODAL.DELIVERY_TITLE`)
                  : t(`SELECT_VENUE_MODAL.PICKUP_TITLE`)}
        </>
    );
};
